export default "__VITE_ASSET__BdXW1$yi__"